module.exports = __webpack_public_path__ + "static/img/14e.e2a5ad0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14e.jpg
// module id = UPbp
// module chunks = 0